import axios from "axios";

const token = localStorage.getItem("authToken");

const instance = axios.create({
	baseURL: "https://backend.talentick.ai/",
	// baseURL: "http://localhost:5000/",

	headers: {
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
		Authorization: `Bearer ${token}`,
	},
});


export default instance;
